import { render, staticRenderFns } from "./DuanDaokaDataLight.vue?vue&type=template&id=489fac5b&scoped=true"
import script from "./DuanDaokaDataLight.vue?vue&type=script&lang=js"
export * from "./DuanDaokaDataLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fac5b",
  null
  
)

export default component.exports